import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';

import classes from './styles/OrderSuccess.module.css';

import Price from '../UI/Price';
import Modal from '../UI/Modal';

const OrderSuccess = ({ onHide, paymentMethod, orderTotal }) => {
  const navigate = useNavigate();

  const handleCopy = async () => {
    await navigator.clipboard.writeText("PORTICO.CASTELAR");
    toast.info("Alias copiado!");
  }

  const handleClick = () => {
    onHide();
    navigate('/home');
  }

  return (
    <Modal onClose={onHide}>
      <div className='text-center'>
        <span className='fa-solid fa-circle-check text-success my-3' style={{ fontSize: '60px'}}></span>
        <p>Pedido realizado con &eacute;xito!</p>

        {paymentMethod === 'transfer' && (
          <p>Debes realizar una transferencia al alias:<br />
          <a href="#" onClick={handleCopy}>PORTICO.CASTELAR</a><br />
          Por un total de <Price value={orderTotal} /> y envianos el comprobante a <a href="https://wa.me/5491178361122?text=Hola,%20envio%20mi%20comprobante" target='_blank'>nuestro WhatsApp</a></p>
        )}

        {paymentMethod === 'cash' && (
          <p>Pago en efectivo</p>
        )}
      </div>
      <div className={classes.actions}>
        <button className="btn bg-white w-100" onClick={handleClick}>
          Cerrar
        </button>
      </div>
    </Modal>
  );
};

export default OrderSuccess;
